module.exports = __webpack_public_path__ + "img/deuxieme.04cc560c.png";